import BaseApi from '@/core/HttpResources/BaseApi';
import NameValue from '@/models/nameValue.model';

export default class NameValueService {

    async  getChildrenByParentCode(nameValueCode: string) {
        let namevalues = await this.getNameValues(nameValueCode);
        return namevalues;
    }

    async getNameValues(nameValueCode: string): Promise<Array<NameValue>> {

        let url = "NameValues/" + nameValueCode + "/children";
        let baseApi = new BaseApi(url);

        return new Promise<Array<NameValue>>((resolve, reject) => baseApi.request('get', String(), null, {}, (response) => resolve(response.data), reject, () => { }))
    }

}